import React from 'react'
import { Badge, Card } from 'antd'

const Tile = ({ title, className = '', recomended = false, children }) => {
  const card = (
    <Card title={title} className={`tile ${className}`} bordered={false}>
      {children}
    </Card>
  )
  if (recomended) {
    return (
      <Badge.Ribbon text={<img src="images/contract/thumb.webp" />}>
        {card}
      </Badge.Ribbon>
    )
  } else {
    return <>{card}</>
  }
}

export default Tile
